<!-- 修改密码 -->
<template>
  <div class="personal-modify-pwd">
    <div>
      <div>
        <h1 class="personal-modify-pwd-title">MSP - Change password</h1>
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <FormItem label=""
                    prop="oldPwd">
            <Input v-model="formValidate.oldPwd"
                   placeholder="Old password"
                   type="password"
                   clearable></Input>
          </FormItem>
          <FormItem label=""
                    prop="newPwd">
            <Input v-model="formValidate.newPwd"
                   placeholder="New password"
                   type="password"
                   clearable></Input>
          </FormItem>
          <FormItem label=""
                    prop="surePwd">
            <Input v-model="formValidate.surePwd"
                   placeholder="New password again"
                   type="password"
                   clearable></Input>
          </FormItem>
        </Form>
        <div class="personal-modify-pwd-btn">
          <Button class="zlr-btn-primary"
                  long
                  :loading="isSub"
                  @click="handleChange">
            Change
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import
import { setToken } from '@/libs/util'
// api
import { subModifyPwd } from '@/api/talents'
// constant
import { subSuc } from '@/constant'
export default {
  name: 'personal-modify-pwd',
  components: {},
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'))
      } else if (value !== this.formValidate.newPwd) {
        callback(new Error('The entered passwords are inconsistent'))
      } else {
        callback()
      }
    }
    return {
      formValidate: {},
      ruleValidate: {
        oldPwd: [{ required: true, message: 'Please enter your old password' }],
        newPwd: [{ required: true, message: 'Please enter your new password' }],
        surePwd: [{ required: true, message: 'Please enter your password' }, { validator: validatePass }]
      },
      isSub: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 提交修改密码
    handleChange () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          this.isSub = true
          subModifyPwd(data).then(res => {
            this.$refs['formValidate'].resetFields()
            this.$zlr_message(subSuc, 'success')
            let timeOut = setTimeout(() => {
              clearTimeout(timeOut)
              setToken('')
              this.$router.replace({
                name: 'login'
              })
            }, 3000)
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
